import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostShippingLabelsParams, TypePostShippingLabelsResponse } from '~/types/delivery-agency.types';

const usePostShippingLabels = () => {
  const { runAsync } = useAsyncHandler();

  const postShippingLabelsCreate = useAPI<TypePostShippingLabelsParams, TypePostShippingLabelsResponse>({
    endpoint: API_ENDPOINT.DELIVERY_AGENCY.POST_SHIPPING_LABELS_CREATE,
    method: 'post',
  });

  const createShippingLabels = (
    params: TypePostShippingLabelsParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: (data: TypePostShippingLabelsResponse['data']) => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runAsync(() => postShippingLabelsCreate({ params }), {
      onSuccess: ({ data }) => onSuccess?.(data),
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { createShippingLabels };
};

export default usePostShippingLabels;
